<template>
  <ion-app>
    <custom-cursor />
    <loading-screen v-if="loading" />
    <toast-container />
    <ion-router-outlet />
  </ion-app>
</template>

<script setup>
import { ref, onMounted, provide } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import LoadingScreen from './components/ui/LoadingScreen.vue';
import ToastContainer from './components/ui/ToastContainer.vue';
import CustomCursor from './components/ui/CustomCursor.vue';

const loading = ref(true);

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 2000);
});
</script>
